module.exports = __webpack_public_path__ + "static/media/Step1.6dca2111.svg";